// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/transport/templates/load.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("e521c4"),
    marko_node0 = marko_createElement("div", {
        "class": "control-group noborder left"
      }, "0", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control-group horizontal noborder left"
        }, null, null, 3)
        .e("input", {
            type: "file",
            id: "file-input",
            hidden: true
          }, null, null, 0)
        .e("label", {
            "class": "ui-button ui-corner-all ui-widget",
            "for": "file-input"
          }, null, null, 1)
          .t("Choose File")
        .e("span", {
            id: "file-chosen"
          }, null, null, 1)
          .t("No file chosen")
      .e("div", {
          "class": "control-group horizontal noborder left"
        }, null, null, 2)
        .e("label", {
            "for": "url-input"
          }, null, null, 1)
          .t("URL")
        .e("input", {
            type: "text",
            id: "url-input"
          }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
